export interface MymachineState {
  stateRestored: boolean
  showConceptNames: boolean
  features: Record<string, boolean>
  serials: Record<string, any>
  ui: {
    currentMachine: Record<string, any>
    authorisation: Record<string, any>
    troubleshooting: {
      keyword: string
      searchType: string
    }
    wrongSN: boolean
  }
  faultcodes: {
    keyword: string
  }
  user: Record<string, any>
  identity: Record<string, any> | null
  language: Record<string, any>
  region: Record<string, any>
  organizations: Record<string, any>
  filteredOrganization: Record<string, any>
  regionConcepts: Record<string, any>
  machinePassword: string | null
  filters: Record<string, any>
}

export const initialState: MymachineState = {
  stateRestored: false,
  showConceptNames: false,
  features: {},
  serials: {},
  ui: {
    currentMachine: {},
    authorisation: {},
    troubleshooting: {
      keyword: '',
      searchType: 'true'
    },
    wrongSN: false
  },
  faultcodes: {
    keyword: ''
  },
  user: {},
  identity: null,
  language: {},
  region: {},
  organizations: {},
  filteredOrganization: {},
  regionConcepts: {},
  machinePassword: null,
  filters: {}
}

export default initialState
